const environment = process.env.REACT_APP_ENV;
//console.log('Environment:', process.env);

export const API_URL = (() => {
  switch (environment) {
    case "prod":
      return "https://api.curesickle.org/cdeService/";
    case "test":
      return "https://cdetestapp.emmes.com/cdeService/";
    default:
      return "http://localhost:9000/";
  }
})();
